import { createSlice } from '@reduxjs/toolkit';
import { IQueryParams } from '../../../models/common/IQueryParams';
import { SORT_TYPE } from '../../../constants';

export interface IExceptionFilterState extends IQueryParams {
  sort: string;
}

const initialState: IExceptionFilterState = {
  searchText: '',
  status: '',
  fromDate: null,
  toDate: null,
  sort: SORT_TYPE.UPDATED_TIMESTAMP_DESC,
};

const exceptionFilterSlice = createSlice({
  name: 'filterException',
  initialState,
  reducers: {
    addFilterExceptionData: (state, action) => {
      state.searchText = action.payload.searchText;
      state.status = action.payload.status;
      state.toDate = action.payload.toDate;
      state.fromDate = action.payload.fromDate;
    },
    addSortExceptionData: (state, action) => {
      state.sort = action.payload;
    },

    clearFilterException: (state) => {
      state.status = '';
      state.toDate = null;
      state.fromDate = null;
      state.sort = '';
    },
    clearQueryParamException: (state) => {
      state.searchText = '';
      state.status = '';
      state.toDate = null;
      state.fromDate = null;
      state.sort = '';
    }
  }
});

export const {
  addFilterExceptionData,
  addSortExceptionData,
  clearFilterException,
  clearQueryParamException,
} = exceptionFilterSlice.actions;

export default exceptionFilterSlice.reducer;
